module.exports = __webpack_public_path__ + "img/momo.99ac3094.png";